import React from 'react';
import { useAuth } from 'react-oidc-context';

const LoginComponent: React.FC = () => {
  const auth = useAuth();

  const handleLogin = () => {
    auth.signinRedirect();
  };

  const handleLogout = () => {
    auth.signoutRedirect();
  };

  if (auth.isLoading) {
    return <div>Carregando...</div>;
  }

  if (auth.error) {
    return <div>Erro: {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div>
        <h2>Bem-vindo, {auth.user?.profile.name || auth.user?.profile.preferred_username}!</h2>
        <div>
          <h3>Informações do usuário:</h3>
          <pre>{JSON.stringify(auth.user?.profile, null, 2)}</pre>
        </div>
        <button onClick={handleLogout} style={{ marginTop: '20px', padding: '10px 20px' }}>
          Logout
        </button>
      </div>
    );
  }

  return (
    <div>
      <h2>Faça login com MT Cidadão</h2>
      <button onClick={handleLogin} style={{ padding: '10px 20px', fontSize: '16px' }}>
        Login com MT Cidadão
      </button>
    </div>
  );
};

export default LoginComponent;